// extracted by mini-css-extract-plugin
module.exports = {"modal":"MinimumOrderModal_modal__H_7th","modalBody":"MinimumOrderModal_modalBody__BmFPg","modalFooter":"MinimumOrderModal_modalFooter__YtxmT"};